<form class="modal-body wrapper-modal position-relative">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
    <section *ngIf="step===1" class="py-0 px-2 px-md-3 px-lg-4">
        <p class="title mx-3">
            Crear servicio consolidado
        </p>
        <p class="mb-3">
            Ingresa los consecutivos de los servicios a enlazar separados por comas. Recuerda que los servicios deben
            estar habilitados y en estado programado o en ruta.
        </p>
        <div class="d-flex flex-wrap mb-3 align-items-baseline">
            <mat-form-field appearance="outline" class="col-sm-8">
                <mat-label>Consecutivos<span class="asterisk">*</span></mat-label>
                <input massivePayments matInput type="text" placeholder="Digita los consecutivos"
                    [formControl]="consecutivesControl">
            </mat-form-field>
            <div class="col-sm-4">
                <button type="button" mat-raised-button class="primary-secondary w-100" color="primary"
                    (click)="searchConsecutives()">Buscar</button>
            </div>
        </div>
        <div class="d-flex flex-wrap mb-3">
            <div *ngFor="let cargoSelected of cargosSelected; let i = index" class="col-12 mb-3">
                <div class="cargo-card" [ngClass]="cargoSelected.errorMessage ? 'error-card' : 'success-card'">
                    <div class="cargo-header">
                        <div class="consecutive">
                            <strong>Consecutivo: {{cargoSelected.cargo.consecutive}}</strong>
                        </div>
                        <small *ngIf="cargoSelected.errorMessage" class="cargo-error-message">
                            {{cargoSelected.errorMessage}}
                        </small>
                    </div>

                    <!-- Información básica de la carga -->
                    <div class="cargo-info">
                        <div class="info-row">
                            <span class="label">Contratante:</span>
                            <span *ngIf="cargoSelected?.cargo?.ministry"
                                class="value">{{cargoSelected?.cargo?.cargoOwner?.name || '-'}}</span>
                            <span *ngIf="!cargoSelected?.cargo?.ministry"
                                class="value">{{cargoSelected?.cargo?.idCompany | companyName}}</span>
                        </div>

                        <div class="info-row">
                            <span class="label">Tipo de viaje:</span>
                            <span class="value">{{cargoSelected?.cargo?.cargoModel?.tripType?.name || '-'}}</span>
                        </div>

                        <div class="info-row">
                            <span class="label">Origen:</span>
                            <span class="value">{{cargoSelected?.cargo?.cargoFeature?.uploadDownload?.origin?.name ||
                                '-'}}</span>
                        </div>

                        <div class="info-row">
                            <span class="label">Fecha origen:</span>
                            <span class="value">{{cargoSelected?.cargo?.dateLoad | dateFormat:'only-date'}}</span>
                        </div>

                        <div class="info-row">
                            <span class="label">Destino:</span>
                            <span class="value">{{getCargoLastDestination(cargoSelected?.cargo)?.name || '-'}}</span>
                        </div>

                        <div class="info-row">
                            <span class="label">Fecha destino:</span>
                            <span class="value">{{getCargoLastDestination(cargoSelected?.cargo)?.downloadDate |
                                dateFormat:'only-date'}}</span>
                        </div>

                        <div class="info-row">
                            <span class="label">Vehículo:</span>
                            <span class="value">{{cargoSelected?.cargo?.licensePlate || 'Sin asignar'}}</span>
                        </div>

                        <div class="info-row">
                            <span class="label">Conductor:</span>
                            <span class="value">{{cargoSelected?.cargo?.driver || 'Sin asignar'}}</span>
                        </div>

                        <div class="info-row">
                            <span class="label">Estado:</span>
                            <span class="value">{{getCargoState(cargoSelected?.cargo) || 'Sin asignar'}}</span>
                        </div>

                        <div class="info-row" *ngIf="cargoSelected?.cargo?.ministry">
                            <span class="label">Tipo de manifiesto:</span>
                            <span class="value">{{cargoSelected?.cargo?.manifestType?.description || '-'}}</span>
                        </div>
                    </div>

                    <!-- Botón para remover cargo -->
                    <div class="cargo-actions">
                        <button type="button" mat-icon-button color="warn" (click)="removeCargo(i)"
                            matTooltip="Remover servicio"
                            *ngIf="cargoSelected?.cargo?.consecutive !== data?.cargo?.consecutive">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="button-container mt-2">
            <button type="button" mat-raised-button color="primary" class="bg-color-primary"
                (click)="nextStep(1)">Siguiente</button>
        </div>
    </section>
    <section *ngIf="step===2" class="py-0 px-2 px-md-3 px-lg-4">
        <p class="title">
            Completa la información adicional
        </p>
        <div class="mb-3">
            <p>
                Selecciona la placa de vehículo que se asignará al servicio consolidado.
                Ten en cuenta que esta placa se asignará y confirmará para todos los servicios seleccionados.
            </p>
            <mat-form-field appearance="outline" class="col-12 col-md-6 ">
                <mat-label>Placa<span class="asterisk">*</span></mat-label>
                <mat-select [formControl]="vehicleSelected">
                    <mat-option *ngFor="let vehicle of vehiclesAllowed" [value]="vehicle">
                        {{vehicle.licensePlate}} - {{vehicle.driver}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="vehicleSelected.errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="mb-3" *ngIf="requiresMiddleAddress">
            <p>
                Para generar el manifiesto de tipo Ida y Vuelta, se debe seleccionar la dirección intermedia.
            </p>
            <mat-form-field appearance="outline" class="col-12 col-md-6 ">
                <mat-label>Dirección intermedia<span class="asterisk">*</span></mat-label>
                <mat-select [formControl]="middleAddressControl">
                    <mat-option *ngFor="let address of middleAddressesAllowed" [value]="address">
                        ({{address?.city}}) {{address?.address?.address}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="middleAddressControl.errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="button-container">
            <button mat-raised-button class="primary-secondary button-width-auto" (click)="backStep()" type="button">
                Atrás
            </button>
            <button type="button" mat-raised-button color="primary" class="bg-color-primary"
                (click)="nextStep(2)">Siguiente</button>
        </div>
    </section>
    <section *ngIf="step===3" class="py-0 px-2 px-md-3 px-lg-4">
        <p class="title">
            Resumen del servicio consolidado
        </p>

        <!-- Resumen de consecutivos -->
        <div class="mb-4">
            <h6 class="font-weight-bold mb-2">Consecutivos de servicios:</h6>
            <div class="d-flex flex-wrap ml-2">
                <span *ngFor="let cargoSelected of cargosSelected; let i = index" class="badge badge-success mr-2 mb-2">
                    {{cargoSelected.cargo.consecutive}}
                </span>
            </div>
        </div>

        <!-- Resumen de direcciones -->
        <div class="mb-4">
            <h6 class="font-weight-bold mb-2">Ruta del servicio consolidado:</h6>
            <div class="route-container ml-2">
                <div *ngFor="let address of addresses; let i = index" class="mb-2">
                    <div class="alert alert-danger mt-2 ml-4 py-2" role="alert"
                        *ngIf="errorOnAddresses?.error && errorOnAddresses?.index === i">
                        <div class="d-flex align-items-center justify-content-between flex-wrap">
                            <div class="d-flex align-items-center flex-grow-1 mr-2 mb-1 mb-md-0">
                                <i class="fas fa-exclamation-triangle mr-2 flex-shrink-0" aria-hidden="true"></i>
                                <small class="mb-0">{{errorOnAddresses?.error}}</small>
                            </div>
                        </div>
                    </div>
                    <div class="route-item d-flex align-items-center">
                        <div class="route-number">{{i + 1}}</div>
                        <div class="route-info flex-grow-1">
                            <div class="route-location">
                                <strong>{{address.city}}</strong> - {{address.address.address}}
                            </div>
                            <div class="route-date text-muted small">
                                {{address.date | dateFormat:'date-time-full'}}
                            </div>
                        </div>
                        <div class="route-type">
                            <span class="badge" [ngClass]="address.type === 'origin' ? 'badge-light' : 'badge-dark'">
                                {{address.type === 'origin' ? 'Origen' : 'Destino'}}
                            </span>
                        </div>
                        <button type="button" class="btn btn-sm btn-edit-route ml-2"
                            (click)="editSection(address.cargoId, address.type)"
                            matTooltip="Editar {{address.type === 'origin' ? 'origen' : 'destino'}}">
                            <i class="fas fa-edit"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Alerta de error en direcciones -->
        <div class="alert alert-danger d-flex align-items-center mb-4" role="alert"
            *ngIf="errorOnAddresses?.error && errorOnAddresses?.index === -1">
            <i class="fas fa-exclamation-triangle mr-2" aria-hidden="true"></i>
            <small class="mb-0">{{errorOnAddresses?.error}}</small>
        </div>

        <!-- Resumen de contratantes -->
        <div class="mb-4">
            <h6 class="font-weight-bold mb-2">Contratantes:</h6>
            <div class="contractors-list d-flex flex-wrap ml-2">
                <div *ngFor="let cargoSelected of cargosSelected"
                    class="contractor-item d-flex justify-content-between align-items-center mb-2 p-2 border rounded mr-2">
                    <span *ngIf="cargoSelected?.cargo?.ministry">
                        {{cargoSelected?.cargo?.cargoOwner?.name || '-'}}
                    </span>
                    <span *ngIf="!cargoSelected?.cargo?.ministry">
                        {{cargoSelected?.cargo?.idCompany | companyName}}
                    </span>
                </div>
            </div>
        </div>

        <!-- Resumen de vehículo y conductor -->
        <div class="mb-4">
            <h6 class="font-weight-bold mb-2">Vehículo y conductor asignado:</h6>
            <div class="vehicle-info p-3 border rounded bg-light ml-2">
                <div class="row">
                    <div class="col-md-6">
                        <strong>Placa:</strong> {{vehicleSelected.value?.licensePlate || '-'}}
                    </div>
                    <div class="col-md-6">
                        <strong>Conductor:</strong> {{vehicleSelected.value?.driver || '-'}}
                    </div>
                </div>
            </div>
        </div>

        <!-- Resumen de tipo de manifiesto -->
        <div class="mb-4" *ngIf="manifestType">
            <h6 class="font-weight-bold mb-2">Tipo de manifiesto:</h6>
            <div class="manifest-info p-3 border rounded bg-light ml-2">
                <strong>{{manifestType.description || '-'}}</strong>
            </div>
        </div>

        <!-- Dirección intermedia si aplica -->
        <div class="mb-4" *ngIf="requiresMiddleAddress && middleAddressControl.value">
            <h6 class="font-weight-bold mb-2">Dirección intermedia:</h6>
            <div class="middle-address-info p-3 border rounded bg-light ml-2">
                <strong>({{middleAddressControl.value?.city}}) {{middleAddressControl.value?.address?.address}}</strong>
            </div>
        </div>

        <div class="col-md-12">
            <div class="button-container">
                <button mat-raised-button class="primary-secondary button-width-auto" (click)="backStep()"
                    type="button">
                    Atrás
                </button>
                <button mat-raised-button color="primary" class="bg-color-primary" (click)="onSubmit()">Crear servicio
                    consolidado</button>
            </div>
        </div>
    </section>
</form>